export default "__VITE_ASSET__CiZcCrek__"